import '../../styles/button.scss';

import { ComponentPropsWithRef, ElementType, forwardRef, JSX, ReactNode, Ref } from 'react';

type ButtonProps<T extends ElementType> = {
  as?: T;
  variant?: 'inverse' | 'secondary' | 'start' | 'warning';
} & ComponentPropsWithRef<T>;

const Button = forwardRef(
  <T extends ElementType = 'button'>(
    { as: Component = 'button', variant, children, ...props }: ButtonProps<T>,
    ref: Ref<T extends keyof JSX.IntrinsicElements ? JSX.IntrinsicElements[T] : T>,
  ) => {
    const className = variant ? `govuk-button govuk-button--${variant}` : 'govuk-button';
    return (
      <Component className={className} data-module="govuk-button" {...props} ref={ref}>
        {children}
      </Component>
    );
  },
);
Button.displayName = 'Button';
export default Button;

export interface ButtonGroupProps {
  children?: ReactNode;
}

export function ButtonGroup(props: ButtonGroupProps) {
  return <div className="govuk-button-group">{props.children}</div>;
}
